/* eslint-disable no-unused-vars */
export const uploadImageFromBackend = async (newFileName, fileType, imageData) => {
    try {
        // let url = "https://tms-api.foxberry.live/v1/upload/photo";
        let url = process.env.REACT_APP_BASE_URL + "/upload/photo";
        let formData = new FormData();
        formData.append("image", imageData);
        formData.append("fileName", newFileName);

        const uploadResponse = await fetch(url, {
            method: "POST",
            body: formData,
        });

        if (uploadResponse.ok) {
            const responseData = await uploadResponse.json();
            return responseData.url;
        } else {
            console.error("File upload failed");
            return "File upload failed";
        }
    } catch (error) {
        console.log("----error*****", error);
        return error;
    }
};

export const getPresignedURL = async (newFileName, fileType, imageData) => {
    const response = await fetch(process.env.REACT_APP_PRESIGNEDURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            fileName: newFileName,
            fileType: fileType,
        }),
    });
    const data = await response.json();
    if (!response.ok) {
        console.error("Error generating pre-signed URL:", data.error);
        return data.error;
    }

    const presignedUrl = data.url;
    const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        headers: { "Content-Type": fileType },
        body: imageData,
    });

    if (uploadResponse.ok) {
        let imageURL = uploadResponse.url.split("?Content-Type=");
        return imageURL[0];
    } else {
        console.error("File upload failed");
        return "File upload failed";
    }
};

export default { uploadImageFromBackend, getPresignedURL };
